import {combineReducers} from "redux";
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {reportsAPI} from "../../../api/reports";
import { createActions } from "../../factory/actionFactory";
import {START} from "../../../constants/action-postfix";
import { loaderReducer } from "./loader/loaderReducer";
import { formReducer } from "./form/formReducer";
import { dataReducer } from "./data/dataReducer";
import { reportParamsReducer } from "./reportParams/reportParamsReducer";
import { getFormParams, getOrgFormattedData } from "../../../utils/smallHelpers";



export const GRADUATES_ORIENTATION_REQUEST = "GRADUATES_ORIENTATION_REQUEST";
export const SET_FORM_DATA = "SET_GRADUATES_ORIENTATION_FORM_DATA";
export const SET_REPORT_PARAMS = "SET_GRADUATES_ORIENTATION_PARAMS";

export const graduatesOrientationReducer = combineReducers({
    form: formReducer,
    data: dataReducer,
    loader: loaderReducer,
    report_params: reportParamsReducer
});

//actions
export const graduatesOrientationActions = createActions('graduatesOrientation', GRADUATES_ORIENTATION_REQUEST);
export const setFormData = payload => ({ type: SET_FORM_DATA, payload});
export const setReportParams = payload => ({ type: SET_REPORT_PARAMS, payload});

// SAGAS
export function* graduatOrientationWatcher() {
    yield takeLatest(`${GRADUATES_ORIENTATION_REQUEST}${START}`, graduatesOrientationWorker)
}

function* graduatesOrientationWorker() {
    try {
        const auth = yield select(state => state.auth.data)
        const form = yield select(state => state.reports.graduatesOrientation.form)
        const payload = getFormParams(form)
        const params = {...auth, ...payload}
        const response = yield call(reportsAPI.graduatesOrientation, params);
        const data = getOrgFormattedData(response.data.Answer.Data)
        yield put(graduatesOrientationActions.graduatesOrientationRequestSuccess(data));
        yield put(setReportParams(form))
    } catch(error) {
        yield put(graduatesOrientationActions.graduatesOrientationRequestError(error));
    }
}